import { createSelector } from '@ngrx/store';
import { IIssueData } from '@partners/api';
import { IRootState } from '../../../root';
import { IIssueState } from './issue.state';

export class IssueSelectors {
  static readonly issueState = (state: IRootState): IIssueState => {
    return state.issue as IIssueState;
  };

  static readonly model = createSelector(IssueSelectors.issueState, (issue: IIssueState) => {
    return issue.model;
  });

  static readonly data = createSelector(IssueSelectors.issueState, (issue: IIssueState) => {
    return issue.data;
  });

  static readonly screenName = createSelector(IssueSelectors.data, (data: IIssueData) => {
    return data?.screenName;
  });
}
